<template>
    <div>
        <div class="py-3" style="">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1 class="d-flex justify-content-center">Users</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="row justify-content-center">
                        <div class="d-flex justify-content-center">
                            <ag-grid-vue style="width:1001px; height: 100%;"
                                         class="ag-theme-balham"
                                         :gridOptions="gridOptions"
                                         :columnDefs="columnDefs"
                                         :rowData="rowData"
                                         rowSelection='single'
                                         domLayout='autoHeight'>
                            </ag-grid-vue>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    // @ is an alias to /src
    import { AgGridVue } from "ag-grid-vue";
    import UserService from '@/services/UserService';

    export default {
        name: 'projectusers',
        components: {
            AgGridVue
        },
        data: function () {
            return {
                loading: true,
                errored: false,
                columnDefs: null,
                gridOptions: null,
                rowData: null
            }
        },
        async beforeMount() {
            this.gridOptions = {
                defaultColDef: {
                    filter: true // set filtering on for all cols
                },
                onGridSizeChanged: () => {
                    this.gridOptions.api.sizeColumnsToFit();
                },
                //select row instead
                suppressCellSelection: true
            }


            this.columnDefs = [
                {
                    headerName: 'Name', field: 'displayName',
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        text.addEventListener('click', (e) => {
                            e.preventDefault
                            this.$router.push({ name: "project-users-edit", params: { id: params.data.id } });
                        });
                        return text;
                    }
                },
                {
                    headerName: 'Email', field: 'mail',
                    //manually binding event to each cell as rowclick is getting auto triggered
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        text.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.$router.push({ name: "project-users-edit", params: { id: params.data.id } });
                        });
                        return text;
                    }
                }
            ];

            this.rowData = await UserService.getUsers();
            this.loading = false;
        },
        mounted() {

        },
        methods: {
        }
    }
</script>